// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_JP2","largestCol":"styles_largestCol__1DZqE","smallestCol":"styles_smallestCol__2cx70"};